// ** React Imports
import PropTypes from 'prop-types';
// ** Reactstrap Imports

// ** Custom Hooks
import { useSkin } from '../utility/hooks/useSkin';
import { useDesignContext } from '../../providers';

// ** Styles
import '../core/scss/base/pages/page-misc.scss';

export function Error({ children }) {
  // ** Hooks
  const { skin } = useSkin();
  const { AppLogo, appName } = useDesignContext();

  const illustration = skin === 'dark' ? 'error-dark.svg' : 'error.svg';
  // eslint-disable-next-line import/no-dynamic-require
  const source = require(`../assets/images/pages/${illustration}`).default;
  return (
    <div className="misc-wrapper">
      <a
        className="brand-logo"
        href="/"
      >
        <AppLogo />
        <h2 className="brand-text text-primary ms-1">{appName}</h2>
      </a>
      <div className="misc-inner p-2 p-sm-3">
        {children}
        <img
          className="img-fluid"
          src={source}
          alt="Not authorized page"
        />
      </div>
    </div>
  );
}

Error.propTypes = {
  children: PropTypes.node
};
export default Error;
